/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Radio from 'common/domain/radio';
import geolocalisationApi from 'statsradio/services/geolocalisationApi';
import GeoMapLayout from 'statsradio/modules/dashboard/domain/GeoMapLayout';
import LoadingGeoMap from './map/LoadingGeoMap';
import GeolocationReach from '../../../domain/GeolocationReach';
import { getCurrentRadio } from '../../../../authentication/session/selectors/sessionSelectors';
import GeolocalisationTopThreeRegions from './GeolocalisationTopThreeRegions';

interface Props {
  geolocalisation: GeolocationReach[];
  radio: Radio;

  t: any,
}

interface State {
  layout?: GeoMapLayout
}

class GeolocalisationCard extends React.Component<Props, State> {

  // Assigning an undefined layout produces a Flow error.
  state = { layout: GeoMapLayout.parse({}) };

  componentDidMount() {
    this.updateLayout();
  }

  componentDidUpdate(prevProps: Props) {
    if (!this.props.radio.isSame(prevProps.radio)) {
      this.updateLayout();
    }
  }

  updateLayout = () => {
    geolocalisationApi
      .fetchVisualMap()
      .then(layout => this.setState({ layout }));
  };

  render() {
    const { geolocalisation } = this.props;
    const { layout } = this.state;

    return (
      <React.Fragment>
        <LoadingGeoMap height={220} geolocalisation={geolocalisation} layout={layout} />
        {layout && <GeolocalisationTopThreeRegions reaches={geolocalisation} layout={layout} />}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    radio: getCurrentRadio(state),
  };
}

export {
  GeolocalisationCard,
};

export default connect(mapStateToProps)(translate()(GeolocalisationCard));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/GeolocalisationCard.js